import { useLocation } from 'react-router-dom'

// Runs guards in order. Returns the first redirect path, or null if all pass.
// Each guard receives meta + the current location and returns a path string or null.
export const useGuards = (guards, meta) => {
  const location = useLocation()

  if (!guards?.length) return null

  for (const guard of guards) {
    const redirectPath = guard({ ...meta, location })
    if (redirectPath) return redirectPath
  }

  return null
}
